<template>
  <DefaultLayout full-bleed :footer-size="footerSize">
    <slot />
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from './DefaultLayout.vue'

defineProps<{
  hiddenFooter?: boolean
  footerSize?: 'large' | 'small'
}>()
</script>
